/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum ExamencijfersUitzondering {
    REGULIER_EXAMENCIJFER = "Regulier examencijfer",
    ASSISTENTENOPLEIDING_ENTREEOPLEIDING = "Assistentenopleiding/Entreeopleiding",
    VAVO_OPLEIDING = "VAVO-opleiding",
    VAKMANSCHAP_TECHNOLOGIE_ROUTE = "Vakmanschap/technologie-route",
    EXTRANEUS = "Extraneus",
    UITGESLOTEN_VAN_ROD_COMMUNICATIE = "Uitgesloten van ROD-communicatie",
    NIET_GESLAAGD_OF_AFGEWEZEN = "Niet geslaagd of afgewezen",
    IN_EERDER_JAAR_GE_XAMINEERD_VAN_GESPREID_EXAMEN = "In eerder jaar ge\u00EBxamineerd van gespreid examen"
}
